import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from "vue";
import TransactionHistoryLoading from "../loading/TransactionHistoryLoading.vue";
import {
	formatAmount,
	formatLargeAmount,
	formatLargePrice,
	formatPrice,
	getMarketCapClass,
	getVolumeClass,
	timeAgo,
} from "@/shared";
import {
	useAlertStore,
	useCacheStore,
	useSwapStore,
	useWalletStore,
} from "@/pinia";
import TokenImage from "../common/TokenImage.vue";
import { fetchTokenPNL, fetchTokenPriceChange } from "@/api/endpoints";
import Spinner from "../common/Spinner.vue";

// props
interface IProps {
	transaction: any;
	idx: number;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TransactionHistory',
  props: {
    transaction: null,
    idx: null
  },
  setup(__props: any) {

const props = __props as {
	transaction: any;
	idx: number;
};



// computed
const currentBalance = computed<number>(() => {
	return cacheStore.getTokenBalance(props.transaction.outMint);
});
const getPrice = computed<number>(() => {
	return cacheStore.getTokenPricesUSD(props.transaction.outMint)?.priceUSD ?? 0;
});
const profitLoss = computed<number>(() => {
	if (getPrice.value == 0 || currentBalance.value == 0) return 0;
	const bsBal = pnl.value?.buyValue - pnl.value?.sellValue;
	return currentBalance.value * getPrice.value - (bsBal < 0 ? 0 : bsBal) || 0;
});
const outAmount = computed<number>(() => {
	return props.transaction.finalBalance - props.transaction.startBalance;
});

// store
const cacheStore = useCacheStore();
const walletStore = useWalletStore();
const swapStore = useSwapStore();
const alertStore = useAlertStore();

// data
const loading = ref<boolean>(true);
const swaping = ref<boolean>(false);
const pnl = ref<any>();
const stats = ref<any>();

// methods
async function mounted() {
	try {
		pnl.value = await fetchTokenPNL({
			mint: props.transaction.outMint,
			wallet: walletStore.address?.toString(),
		});

		await cacheStore.fetchMintPriceUSD(props.transaction.outMint);
		stats.value = await fetchTokenPriceChange(props.transaction.outMint);
	} finally {
		loading.value = false;
	}
}
async function sell() {
	try {
		if (swaping.value) return;
		swaping.value = true;

		if (!outAmount.value) return;

		const data = {
			id: Date.now(),
			wallet: walletStore.address?.toString(),
			inMint: props.transaction.outMint,
			outMint: props.transaction.inMint,
			inAmount: outAmount.value,
		};

		await swapStore.doSwap(data);

		swapStore.removeTransactionHistory({ wallet: data.wallet, idx: props.idx });
	} finally {
		swaping.value = false;
	}
}

// setup
onMounted(mounted);

return { __sfc: true,props, currentBalance, getPrice, profitLoss, outAmount, cacheStore, walletStore, swapStore, alertStore, loading, swaping, pnl, stats, mounted, sell, TransactionHistoryLoading, formatAmount, formatLargePrice, formatPrice, getVolumeClass, timeAgo, TokenImage, Spinner }
}

})